var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"google-signin-button",rawName:"v-google-signin-button",value:(_vm.value),expression:"value"}],staticClass:"google-signin-button",attrs:{"id":"teste-google"}},[_vm._v("Fazer Integração")])
}
var staticRenderFns = []

export { render, staticRenderFns }